import {Component, OnChanges, SimpleChanges} from '@angular/core';
import {CapitalCasePipe} from "../../../../pipes/capital-case.pipe";
import {
    DxButtonComponent,
    DxDataGridComponent,
    DxTemplateDirective
} from "devextreme-angular";
import {
    DxiButtonComponent,
    DxiColumnComponent,
    DxiItemComponent, DxoColumnChooserComponent,
    DxoExportComponent, DxoFilterRowComponent, DxoHeaderFilterComponent, DxoLoadPanelComponent, DxoPagerComponent, DxoPagingComponent,
    DxoScrollingComponent, DxoSortingComponent, DxoToolbarComponent
} from "devextreme-angular/ui/nested";
import {TimeOffRequestsComponent} from "../time-off-requests.component";
import {FloaterDayGridViewDto} from "@services";
import {UserAvatarEmailComponent} from "../../../../components/utils/user-avatar-email/user-avatar-email.component";
import {NgClass} from "@angular/common";
import {FloaterDayPopupComponent} from "./floater-day-popup/floater-day-popup.component";
import {TimeOffFilterPanelComponent} from "../time-off-filter-panel/time-off-filter-panel.component";

@Component({
    selector: 'app-floater-days',
    imports: [
        CapitalCasePipe,
        DxButtonComponent,
        DxDataGridComponent,
        DxTemplateDirective,
        DxiButtonComponent,
        DxiColumnComponent,
        DxiItemComponent,
        DxoColumnChooserComponent,
        DxoExportComponent,
        DxoFilterRowComponent,
        DxoHeaderFilterComponent,
        DxoLoadPanelComponent,
        DxoPagerComponent,
        DxoPagingComponent,
        DxoScrollingComponent,
        DxoSortingComponent,
        DxoToolbarComponent,
        UserAvatarEmailComponent,
        NgClass,
        FloaterDayPopupComponent,
        TimeOffFilterPanelComponent
    ],
    templateUrl: './floater-days.component.html'
})
export class FloaterDaysComponent extends TimeOffRequestsComponent<FloaterDayGridViewDto> implements OnChanges {
    constructor() {
        super();
        this.init(FloaterDayGridViewDto);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['employeeId']) {
            this.dataSource = this.dataSources.floaterDays(this.employeeId);
        }
    }

    dataSource = this.dataSources.floaterDays(null);
    filterModel: FloaterDayGridViewDto = new FloaterDayGridViewDto();
    gridFieldName = (name: keyof FloaterDayGridViewDto): string => name;
    filterModelName = (name: keyof FloaterDayGridViewDto): string => name;
    protected override exportName: string = "Floater Days";
    protected tabName = 'floater-day';

    getCellData(cellInfo: { data: FloaterDayGridViewDto }) {
        return cellInfo.data;
    }
}
